import { render } from "./VideoElement.vue?vue&type=template&id=86bed1e0&scoped=true"
import script from "./VideoElement.vue?vue&type=script&lang=js"
export * from "./VideoElement.vue?vue&type=script&lang=js"

import "./VideoElement.vue?vue&type=style&index=0&id=86bed1e0&scoped=true&lang=scss"
import "./VideoElement.vue?vue&type=style&index=1&id=86bed1e0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86bed1e0"]])

export default __exports__